export enum ROLE_ENUM {
  ADMIN = "admin",
  SUPER_ADMIN = "super",
}
